import cx from "classnames";

interface TimeWindowSectionTitleProps {
  className?: string;
  title: string;
}

export default function TimeWindowSectionTitle({
  title,
  className,
}: TimeWindowSectionTitleProps) {
  return (
    <h2
      className={cx(
        "leading-normal text-sm font-medium text-text-secondary",
        className
      )}
    >
      {title}
    </h2>
  );
}
